import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { DeceasedState, DeceasedStateName } from '@frontend/deceased/types';
import React from 'react';

const ID = 'deceased-state-select';

export interface DeceasedStateSelectProps extends Omit<SelectInputV2Props<DeceasedStateName>, 'options'> {
    states?: DeceasedStateName[];
}

export const DeceasedStateSelect = ({ states, ...props }: DeceasedStateSelectProps) => {
    const availableStates = states ? DeceasedState.ALL.filter((state) => states.includes(state.name)) : DeceasedState.ALL;

    return (
        <SelectInputV2
            {...props}
            id={ID + props.id}
            label={props.label || 'Deceased state'}
            options={availableStates.map((state) => ({ value: state.name, label: state.name, display: state.display }))}
        />
    );
};

export default DeceasedStateSelect;
